import { useCan } from '@refinedev/core';
import { Button, Result, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import type { ReactNode } from 'react';

type RequireAccessProps = {
  resource: string;
  action: string;
  children: ReactNode;
};

/**
 * Роут-гейт по правам через `accessControlProvider`.
 *
 * Пока право проверяется — спиннер; без права — экран 403 с причиной
 * (списком требуемых прав) и кнопкой на главную. Клиентский гейтинг — UX,
 * источник истины — серверная проверка прав.
 */
export function RequireAccess({ resource, action, children }: RequireAccessProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { data, isLoading } = useCan({ resource, action });

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', paddingBlock: 80 }}>
        <Spin />
      </div>
    );
  }

  if (data?.can) {
    return <>{children}</>;
  }

  return (
    <Result
      status="403"
      title={t('access.title')}
      subTitle={data?.reason}
      extra={
        <Button
          type="primary"
          onClick={() => {
            void navigate('/');
          }}
        >
          {t('access.backHome')}
        </Button>
      }
    />
  );
}
